var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActive),expression:"isActive"}],staticClass:"tabs-component-panel",attrs:{"aria-hidden":!_vm.isActive,"id":_vm.computedId,"role":"tabpanel"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }